/**
 * Second image on hover, for product cards that use the swipeable slider.
 *
 * The theme renders card media either as a slider (show_swipeable_images) or as a
 * featured image with a secondary image revealed on hover — never both, because the
 * secondary-image markup lives in the `else` branch of the slider condition. With the
 * slider on, the hover image is therefore never rendered at all.
 *
 * Rather than fork the markup, this drives the slider that is already there: on a
 * hover-capable desktop pointer it scrolls the card's track to the second slide and
 * back out again. Touch devices never match the query, so swiping is untouched, and
 * nothing here runs if the card has only one image.
 */
(() => {
  const DESKTOP_HOVER = '(hover: hover) and (pointer: fine) and (min-width: 990px)';
  const query = window.matchMedia(DESKTOP_HOVER);

  const trackFor = (card) => {
    const track = card.querySelector('.card__media .slider');
    if (!track) return null;
    return track.querySelectorAll('.slider__slide').length > 1 ? track : null;
  };

  const slideTo = (track, index) => {
    const slide = track.querySelectorAll('.slider__slide')[index];
    if (!slide) return;
    // scrollLeft rather than scrollIntoView: the latter also scrolls the page when the
    // card sits partly out of view.
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };

  const onEnter = (event) => {
    const card = event.target.closest?.('.card-wrapper');
    if (!card || !query.matches) return;
    const track = trackFor(card);
    if (track) slideTo(track, 1);
  };

  const onLeave = (event) => {
    const card = event.target.closest?.('.card-wrapper');
    if (!card || !query.matches) return;
    const track = trackFor(card);
    if (track) slideTo(track, 0);
  };

  // Delegated on the document so cards appended by Load more and by the filter
  // re-render are covered without rebinding.
  document.addEventListener('mouseover', (event) => {
    const card = event.target.closest?.('.card-wrapper');
    if (card && !card.contains(event.relatedTarget)) onEnter(event);
  });

  document.addEventListener('mouseout', (event) => {
    const card = event.target.closest?.('.card-wrapper');
    if (card && !card.contains(event.relatedTarget)) onLeave(event);
  });
})();
